module.exports = __webpack_public_path__ + "images/emoji/symbols.eecbab2f643ddffe01ff.png";